import { DEFAULT_MODE } from '@tornado-rdk/theme';
import { getScreenSize } from './sizes';

export const FOCUSED_Z_INDEX = 10;

export const UNFOCUSED_Z_INDEX = 0;

/**
 * Creates a string from a context allowing to access cache entries
 *
 * @param {Object} context
 * @returns {string}
 */
export const cacheResolver = context =>
  context
    ? Object.keys(context)
        .map(key => `${key}=${context[key]}`)
        .join(',')
    : '';

/**
 * Generates a default data for styling, containing current screen resolution and default color mode
 *
 * @returns {Object}
 */
export const makeDefaultStylingContext = () => ({ screenSize: getScreenSize(), colorMode: DEFAULT_MODE });
